import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type RootProps = ComponentProps<'div'>;

export function Root({ className, ...props }: RootProps) {
  return (
    <>
      <div
        className={twMerge(
          'invisible fixed z-[15] hidden w-screen items-center justify-center bg-white shadow-md lg:visible lg:flex',
          className,
        )}
        {...props}
      />

      <div className="h-nav-bar-height invisible hidden lg:block" />
    </>
  );
}
